import { ProductPublicModels } from '@features/products/product';

export const hasScroll = 'has-scroll';

export const isPdpExtraInfoOpen = 'is-pdp-extra-info-open';

export interface AddToCartSheetModel {
    product: ProductPublicModels.PublicProduct;
    categoryId: string;
    fullView: boolean;
}
